// extracted by mini-css-extract-plugin
export default {"gate":"Gate_gate__KP+Ki"};